import * as THREE from 'three';

// Abstract base class for 3D objects (Strategy Pattern)
export abstract class ThreeDObject {
    abstract create(): THREE.Object3D;
    abstract animate(time: number): void;
}
